import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import overrideStyle from 'lib/overrideStyle';

import AnswerItem from './AnswerItem';
import { getQuickActions } from 'app/modules';

export const StyledQuickActions = overrideStyle('div')`
  flex: 1;
  padding-left: 15px;
  padding-top: 150px;
`;

class QuickActions extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <StyledQuickActions>
        {this.props.suggestedAnswers.map((answer, index) => (
          <AnswerItem answer={answer} key={index} />
        ))}
      </StyledQuickActions>
    );
  }
}

QuickActions.propTypes = {
  suggestedAnswers: PropTypes.array,
};

const mapStateToProps = (state, props) => {
  return { suggestedAnswers: getQuickActions(state), ...props };
};

export { QuickActions };
export default connect(mapStateToProps)(QuickActions);
